import * as moment from 'moment';
import 'rxjs/add/operator/takeUntil';
import { UserNotificationActionType, NotificationService, } from './notification.service';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import { ChallengeService } from 'app/shared/services/challenge.service';
import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
var UserNotificationComponent = (function () {
    function UserNotificationComponent(notificationService, challengeService, router, snackBar, translate) {
        this.notificationService = notificationService;
        this.challengeService = challengeService;
        this.router = router;
        this.snackBar = snackBar;
        this.translate = translate;
        this.ngUnsubscribe = new Subject();
        this.snackbarDisplayState = 'hidden';
        this.snackbarOptions = {
            message: '',
            visible: false,
            duration: -1,
            dismissible: false,
            color: '#000000',
            buttons: [],
        };
    }
    UserNotificationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.notificationService.notificationOptionsObservable.takeUntil(this.ngUnsubscribe).subscribe(function (value) {
            if (value.visible) {
                if (_this.snackbarOptions.visible) {
                    _this.snackbarDisplayState = 'hidden';
                    clearTimeout(_this.timeout);
                    setTimeout(function () {
                        _this.snackbarDisplayState = 'shown';
                    }, 250);
                }
                else {
                    _this.snackbarDisplayState = 'shown';
                }
                _this.snackbarOptions = value;
                if (_this.snackbarOptions.duration > 0) {
                    _this.timeout = setTimeout(function () {
                        _this.notificationService.dismiss();
                    }, _this.snackbarOptions.duration);
                }
            }
            else {
                _this.snackbarDisplayState = 'hidden';
            }
        });
    };
    UserNotificationComponent.prototype.buttonClicked = function (action) {
        var _this = this;
        if (!action) {
            return;
        }
        switch (action.type) {
            case UserNotificationActionType.ACCEPT_APPLICATION: {
                this.challengeService.displayedChallenge.take(1).subscribe(function (challenge) {
                    if (challenge && (challenge._id !== action.challengeID || moment(challenge.start).isBefore(moment()))) {
                        _this.translate.get('CHALLENGE.error.preparationPhaseOver').subscribe(function (text) {
                            _this.snackBar.open(text, null, {
                                verticalPosition: 'top',
                                duration: 8000,
                                panelClass: ['b2a-error', 'top'],
                            });
                        });
                    }
                    else {
                        _this.challengeService.acceptApplication(action.challengeID, action.teamID, action.userID).catch(function (error) {
                            var errorObject = error.body.error.error;
                            if (errorObject.startsWith('maximum_challenge_members')) {
                                _this.translate.get('CHALLENGE.error.maximumChallengeMemberReached').subscribe(function (text) {
                                    _this.snackBar.open(text, null, {
                                        verticalPosition: 'top',
                                        duration: 4000,
                                        panelClass: ['b2a-error', 'top'],
                                    });
                                });
                            }
                        });
                        _this.dismiss();
                    }
                });
                break;
            }
            case UserNotificationActionType.REJECT_APPLICATION: {
                this.challengeService.displayedChallenge.take(1).subscribe(function (challenge) {
                    if (challenge && (challenge._id !== action.challengeID || moment(challenge.start).isBefore(moment()))) {
                        _this.translate.get('CHALLENGE.error.preparationPhaseOver').subscribe(function (text) {
                            _this.snackBar.open(text, null, {
                                verticalPosition: 'top',
                                duration: 8000,
                                panelClass: ['b2a-error', 'top'],
                            });
                        });
                    }
                    else {
                        _this.challengeService.cancelApplication(action.challengeID, action.teamID, action.userID);
                        _this.dismiss();
                    }
                });
                break;
            }
            case UserNotificationActionType.MANAGE_TEAM: {
                this.router.navigate(['stats']).then();
                break;
            }
            case UserNotificationActionType.SELECT_TEAM: {
                this.challengeService.displayedChallenge.take(1).subscribe(function (challenge) {
                    if (challenge && (challenge._id !== action.challengeID || moment(challenge.start).isBefore(moment()))) {
                        _this.translate.get('CHALLENGE.error.preparationPhaseOver').subscribe(function (text) {
                            _this.snackBar.open(text, null, {
                                verticalPosition: 'top',
                                duration: 8000,
                                panelClass: ['b2a-error', 'top'],
                            });
                        });
                    }
                    else {
                        _this.router.navigate(['challenge', action.challengeID, 'team']).then();
                    }
                });
                break;
            }
            default: {
                break;
            }
        }
    };
    UserNotificationComponent.prototype.dismiss = function () {
        clearTimeout(this.timeout);
        this.notificationService.dismiss();
    };
    UserNotificationComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return UserNotificationComponent;
}());
export { UserNotificationComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/user-notification/user-notification.component.ts.pre-build-optimizer.js